// extracted by mini-css-extract-plugin
export default {"FormCheckbox":"FormCheckbox_FormCheckbox__h092o","rotation":"FormCheckbox_rotation__2HNDl"};